import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCheckmark = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m33.964 85.821-32.5-32.5a5 5 0 0 1 0-7.071l7.071-7.071a5 5 0 0 1 7.071 0L37.5 61.072 84.394 14.18a5 5 0 0 1 7.07 0l7.072 7.07a5 5 0 0 1 0 7.072l-57.5 57.5a5 5 0 0 1-7.072 0Z" })
});
export default SvgIconCheckmark;
